/* istanbul ignore file */
import i18next, { InitOptions } from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
const languageDomNode = document.documentElement;
const i18nVersionNode = document.querySelector("meta[name='i18n_version']");

const i18nVersion = i18nVersionNode && i18nVersionNode.getAttribute("content");
export const language = languageDomNode?.lang;

const i18nConfig: InitOptions = {
  lng: language || "pl",
  fallbackLng: "pl",
  ns: ["messages", "messagesCustom"], // domyślnie taka kolejność, żeby działały standardowe tłumaczenia w przypadk uużycia hook'a useTranslate()
  //defaultNS: "messagesCustom",
  //fallbackNS: "messages", // jeżeli ta opcja jest ustawiona to nie ma możliwości tłumaczenia tylko z "messagesCustom"
  nsSeparator: false, // musi być false, jeżeli w źródłowym tłumaczeniu może być ":"
  keySeparator: false, // musi być false, jeżeli w źródłowym tłumaczeniu może być "."
  interpolation: {
    escapeValue: false, // niepotrzebne w React
  },
  react: {
    useSuspense: false,
  },
  backend: {
    loadPath: "/assets/{{ns}}.json?lang={{lng}}",
    allowMultiLoading: true,
    queryStringParams: {
      v: i18nVersion ?? "",
    },
  },
};

i18next.use(HttpApi).use(initReactI18next).init(i18nConfig);
